module.exports = __webpack_public_path__ + "static/media/eat_healthy.3553eac4.svg";